/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'
import { useFsiActionMenu } from '../../../hooks/useFsiActionMenu'

interface VersionInfo {
  versionId?: number
  minorVersionId?: number
}

interface DocumentsActivityPageMenuProps {
  fsi: any
  options?: {
    hideActivity?: boolean
  }
  isNotEffectiveVersion?: boolean
  versionInfo?: VersionInfo
  setIsFormSubmitted: (value: boolean) => void
  setIsReportExport: (value: boolean) => void
}

export const DocumentsActivityPageMenu: React.FC<DocumentsActivityPageMenuProps> = ({
  fsi,
  options = { hideActivity: true },
  isNotEffectiveVersion = false,
  versionInfo = {},
  setIsFormSubmitted,
  setIsReportExport
}) => {
  const { items, setIsOpen } = useFsiActionMenu(fsi, options, isNotEffectiveVersion, versionInfo)

  const dynamicActionMenuItem = [
    {
      value: 'ACTION_EXPORT',
      action: () => {
        setIsReportExport(true)
        setIsFormSubmitted(true)
      }
    },
    {
      divider: true
    }
  ]

  return (
    <div>
      <ActionsMenuBig
        menuId="page"
        onToggle={(open) => {
          setIsOpen(open)
        }}
        items={[...dynamicActionMenuItem, ...items]}
      />
    </div>
  )
}

export default DocumentsActivityPageMenu
